import React from "react";
import {formatCurrency} from "../../utils/format";
import {AccordionHeader, Dropdown} from "../../components";
import {MemberType} from "../../ClientManagement/models/MemberType";
import {NO_OP} from "../../constants/common";

type BeneficiaryGoalsAccordionHeaderProps = { memberSelected: MemberType, dropdownItems: JSX.Element[], totalMyResponsibility: number }
const BeneficiaryGoalsAccordionHeader = ({
                                             memberSelected,
                                             dropdownItems,
                                             totalMyResponsibility
                                         }: BeneficiaryGoalsAccordionHeaderProps) => (
    <>
        <div className="section-header">
            <h3>
                You plan to fund <b>{formatCurrency(totalMyResponsibility)}</b> of {memberSelected.firstName}'s goals.
            </h3>
            <div>
                <Dropdown
                    className="dropdown--rounded"
                    buttonSize="medium"
                    alignRight
                    buttonIcon="left"
                    buttonKind="primary"
                    drop="down"
                    dropdownKind="menu"
                    defaultText="Add Goal"
                    iconNameOpen="add"
                    iconNameClose="add"
                    panelWidth={"auto"}
                    rounded
                    aria-label="add-new-goal"
                >
                    {dropdownItems}
                </Dropdown>
            </div>
        </div>
        <div data-testid="family-goal-underline-item">
            <AccordionHeader columnTitles={["Name", "Present Value", "Family Assets", "My Responsibility"]}
                             onClick={NO_OP}
                             className={'family-goals-accordion-header-grid'}
                             showIcon={false}
            />
        </div>
    </>
)

export default BeneficiaryGoalsAccordionHeader;
